<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
                        @change="inputChange">
                        <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开销内容：">
                    <el-input v-model="formInline.content" placeholder="请输入报销内容" clearable size="small"
                        @change="inputChange"></el-input>
                </el-form-item>
                <el-form-item label="是否确认：">
                    <el-select v-model="formInline.isConfirm" placeholder="请选择是否确认" clearable filterable size="small"
                        @change="inputChange">
                        <el-option label="已确认" value="1"></el-option>
                        <el-option label="未确认" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="btnPermission.search" size="small" type="primary" class="el-icon-search"
                        @click="inputChange()">
                        搜索
                    </el-button>
                    <el-button v-if="btnPermission.create" size="small" type="primary" class="el-icon-plus"
                        @click="handleEdit()">新增
                    </el-button>
                </el-form-item>
            </el-form>
            <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
                @rowDBClick="handleEdit" border stripe>
                <el-table-column align="center" slot="isConfirm" label="是否确认" width="120" fixed="left">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isConfirm" type="success">已确认</el-tag>
                        <el-tag v-else type="danger">未确认</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" slot="operation" label="操作" width="170" v-if="btnPermission.confirm"
                    fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isConfirm == false && btnPermission.delete" size="mini" type="danger"
                            class="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
                        <el-button v-if="scope.row.isConfirm == false && btnPermission.confirm" size="mini"
                            type="primary" class="el-icon-finished" @click="handleConfirm(scope.row)">确认</el-button>
                    </template>
                </el-table-column>
            </STable>
            <!-- 分页组件 -->
            <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </topTab>
        <!-- 编辑 -->
        <edit ref="edit"></edit>
    </div>
</template>

<script>
import {
    GetStoreExpensePageList,
    ConfirmStoreExpense,
    DeleteStoreExpense
} from "@/api/storeCostApi.js";
import {
    GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import edit from "./edit.vue";
export default {
    data() {
        return {
            activeTab: "1",
            tabData: [
                {
                    key: "1",
                    value: "报销记录",
                },
            ],
            pageShow: true,
            loading: false, // 显示加载
            listData: [],
            selectionList: [],
            // 分页参数
            pageparm: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
            formInline: {
                pageIndex: 1,
                pageSize: 10,
                storeKeyId: "",
                content: "",
                isConfirm: null,
            },
            storeList: [],
            columnsData: [],
            listColumns: [
                {
                    prop: "rowNumber",
                    label: "序号",
                    align: "center",
                    fixed: "left",
                    width: "80",
                    isKeep: true,
                },
                {
                    prop: "storeName",
                    label: "门店名称",
                    isKeep: true,
                    minWidth: "120",
                    fixed: "left",
                    align: "center",
                },
                {
                    slot: "isConfirm",
                    label: "是否确认",
                    width: "120",
                    fixed: "left",
                    align: "center",
                },
                {
                    prop: "content",
                    label: "开销内容",
                    minWidth: "200",
                    align: "center",
                },
                {
                    prop: "expenseMoney",
                    label: "金额",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "confirmUserName",
                    label: "确认人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "confirmTime",
                    label: "确认时间",
                    width: "170",
                    align: "center",
                },
                {
                    prop: "creator",
                    label: "经办人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "createTime",
                    label: "经办时间",
                    width: "170",
                    align: "center",
                },
                {
                    slot: "operation",
                    label: "操作",
                    width: "170",
                    align: "center",
                },
            ],
            btnPermission: {
                confirm: false,
                search: false,
                create: false,
                update: false,
                delete: false,
            },
        };
    },
    // 注册组件
    components: {
        edit,
    },
    created() {
        // 初始列
        this.getCheckBox(this.listColumns.map((item) => item.label));
        this.getListData();
        this.GetOrgInfoListByConfig();
        // 按钮权限
        this.btnPermission.confirm = this.$checkBtnPermission('/storeCost/expense', 'confirm');
        this.btnPermission.search = this.$checkBtnPermission('/storeCost/expense', 'viewPage');
        this.btnPermission.create = this.$checkBtnPermission('/storeCost/expense', 'create');
        this.btnPermission.update = this.$checkBtnPermission('/storeCost/expense', 'update');
        this.btnPermission.delete = this.$checkBtnPermission('/storeCost/expense', 'delete');
    },
    computed: {},
    methods: {
        // 获取筛选框
        getCheckBox(val) {
            let arr = this.listColumns.filter((v) => !val.includes(v.label));
            this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
        },
        changePages() { },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        res.data.forEach((item) => {
                            this.storeList.push({
                                keyId: item.keyId,
                                value: item.name + '【' + item.remark2 + '】',
                            });
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        //显示编辑界面
        handleEdit(row) {
            this.$refs.edit.editShow(row);
        },
        // 获取列表
        getListData() {
            this.loading = true;
            GetStoreExpensePageList(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data;
                        this.pageparm.total = res.totalNumber;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                });
        },
        inputChange(val) {
            this.search();
        },
        // 分页插件事件
        callFather(parm) {
            if (parm.currentPage == undefined) {
                this.formInline.pageIndex = 1;
            } else {
                this.formInline.pageIndex = parm.currentPage;
            }
            this.formInline.pageSize = parm.pageSize;
            this.getListData();
        },
        // 搜索事件
        search() {
            this.formInline.pageIndex = 1;
            this.pageShow = false;
            this.$nextTick(() => {
                this.pageShow = true;
            });
            this.getListData();
        },
        // 确认
        handleConfirm(row) {
            if (!this.btnPermission.confirm) {
                this.$message({
                    type: "error",
                    message: "您没有确认权限，请联系管理员！",
                });
                return;
            }
            //弹窗确认
            this.$confirm("确认确认吗？", "确认", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                ConfirmStoreExpense({
                    keyId: row.keyId,
                }).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: "确认成功",
                        });
                        this.getListData();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                })
                    .catch((err) => {
                        this.$message.error("确认失败，请稍后再试！");
                    });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消确认",
                });
            });
        },
        // 删除
        handleDelete(row) {
            if (!this.btnPermission.delete) {
                this.$message({
                    type: "error",
                    message: "您没有删除权限，请联系管理员！",
                });
                return;
            }
            //弹窗确认
            this.$confirm("确认删除吗？", "删除", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                DeleteStoreExpense({
                    keyId: row.keyId,
                }).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: "删除成功",
                        });
                        this.getListData();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                }).catch((err) => {
                    this.$message.error("删除失败，请稍后再试！");
                });
            });
        },
    },
};
</script>

<style scoped></style>